import {
  image_default
} from "./chunk-GEM7KXV7.js";
import {
  buildNextSanityImage,
  isSanityImageProps
} from "./chunk-PYPRNX3I.js";

// src/blocks/image/sanity-image.tsx
import { jsx } from "react/jsx-runtime";
var SanityImage = (props) => {
  if (!isSanityImageProps(props)) return /* @__PURE__ */ jsx(image_default, { ...props });
  if (typeof props.sanityImageSourceData === "string") {
    const { sanityImageSourceData: sanityImageSourceData2, ...rest2 } = props;
    return /* @__PURE__ */ jsx(image_default, { src: sanityImageSourceData2, ...rest2 });
  }
  const { width, height, sanityImageSourceData, ...rest } = props;
  const imageProps = buildNextSanityImage(
    sanityImageSourceData,
    {},
    { width, height }
  );
  if (imageProps === null) return null;
  return /* @__PURE__ */ jsx(image_default, { ...imageProps, ...rest });
};
var sanity_image_default = SanityImage;

export {
  sanity_image_default
};
